/* ============================================================
   MOTION DRIVEN — THEME JS (Shopify)
   Announcement rotation · header/nav · reveals · counters ·
   countdown · accordions · AJAX cart · variant picker
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Toast ---------- */
  function toast({ title, sub = "", img = "" }) {
    const wrap = $("#toastWrap");
    if (!wrap) return;
    const t = document.createElement("div");
    t.className = "toast";
    t.innerHTML = `${img ? `<img src="${img}" alt="">` : `<span class="toast-check">✓</span>`}
      <div><div class="toast-title">${title}</div>${sub ? `<div class="toast-sub">${sub}</div>` : ""}</div>
      <a href="${window.MDConfig.cartUrl}">View cart</a>`;
    wrap.appendChild(t);
    setTimeout(() => { t.classList.add("out"); setTimeout(() => t.remove(), 400); }, 4200);
  }

  /* ---------- Announcement rotation ---------- */
  const msgEl = $("#announceMsg");
  if (msgEl) {
    let msgs = [];
    try { msgs = JSON.parse(msgEl.dataset.msgs).filter(Boolean); } catch (e) {}
    if (msgs.length > 1) {
      const speed = parseInt(msgEl.dataset.speed, 10) || 4500;
      let i = 1;
      setInterval(() => {
        msgEl.textContent = msgs[i % msgs.length];
        msgEl.classList.remove("announce-msg"); void msgEl.offsetWidth; msgEl.classList.add("announce-msg");
        i++;
      }, speed);
    }
  }

  /* ---------- Header scroll + mobile nav ---------- */
  const header = $("#siteHeader");
  if (header) {
    if (!document.body.classList.contains("has-hero")) header.classList.add("solid");
    const onScroll = () => header.classList.toggle("scrolled", window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }
  const burger = $("#hamburger"), mnav = $("#mobileNav");
  if (burger && mnav) {
    const syncNavTop = () => {
      if (!header) return;
      const bottom = Math.max(header.getBoundingClientRect().bottom, 0);
      mnav.style.top = bottom + "px";
    };
    const setOpen = (open) => {
      if (open) syncNavTop();
      mnav.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open);
      if (header) header.classList.toggle("menu-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    };
    burger.addEventListener("click", () => setOpen(!mnav.classList.contains("open")));
    // Close when a link is tapped
    mnav.addEventListener("click", (e) => { if (e.target.closest("a")) setOpen(false); });
    // Close + reset if resized up to desktop; re-sync top on orientation change
    window.addEventListener("resize", () => {
      if (window.innerWidth > 900 && mnav.classList.contains("open")) setOpen(false);
      else if (mnav.classList.contains("open")) syncNavTop();
    });
  }

  /* ---------- Reveals + stagger + parallax ---------- */
  const revealEls = $$(".reveal, .reveal-l, .reveal-r, .stagger");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
    }), { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    revealEls.forEach(e => io.observe(e));
  } else revealEls.forEach(e => e.classList.add("in"));

  const pEls = $$("[data-parallax]");
  if (pEls.length && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    let ticking = false;
    const upd = () => {
      pEls.forEach(el => {
        const sp = parseFloat(el.dataset.parallax) || .1;
        const r = el.getBoundingClientRect();
        el.style.transform = `translateY(${((r.top + r.height / 2 - innerHeight / 2) * -sp).toFixed(1)}px)`;
      });
      ticking = false;
    };
    window.addEventListener("scroll", () => { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }, { passive: true });
    upd();
  }

  /* ---------- Counters ---------- */
  const counters = $$("[data-count]");
  if (counters.length && "IntersectionObserver" in window) {
    const run = el => {
      const target = parseFloat(el.dataset.count), t0 = performance.now();
      const step = now => {
        const k = Math.min(1, (now - t0) / 1400), e = 1 - Math.pow(1 - k, 3);
        el.textContent = Math.round(target * e).toLocaleString("en-US");
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const cio = new IntersectionObserver(es => es.forEach(en => {
      if (en.isIntersecting) { run(en.target); cio.unobserve(en.target); }
    }), { threshold: .4 });
    counters.forEach(el => cio.observe(el));
  }


  /* ---------- Badge sync: corrects cached entry numbers on load ----------
     Shopify caches storefront HTML, so server-rendered multipliers can be
     stale for a few minutes after a settings change or a scheduled phase
     flip. This recomputes every badge, the PDP strip, and the cart total
     client-side from MDConfig — the browser clock is the source of truth. */
  function mdCurrentPromo() {
    const c = window.MDConfig || {};
    if (c.gwActive === false) return { active: false, mult: 1 };
    const now = Date.now() / 1000;
    if (c.startEpoch && now < c.startEpoch) return { active: false, mult: 1 };
    if (Array.isArray(c.phases) && c.phases.length) {
      const p = c.phases.find(p => p.end > now);
      if (p && p.mult > 1) return { active: true, mult: p.mult };
      return { active: false, mult: 1 };
    }
    if (c.endEpoch && now <= c.endEpoch && c.multiplier > 1) return { active: true, mult: c.multiplier };
    return { active: false, mult: 1 };
  }
  function mdSyncBadges() {
    const ph = mdCurrentPromo();
    document.querySelectorAll("[data-eb]").forEach(el => {
      const base = parseFloat(el.dataset.base) || 0;
      const q = parseFloat(el.dataset.q) || 1;
      const pm = parseFloat(el.dataset.pmult) || 0;
      const active = pm > 1 ? true : ph.active;
      const mult = pm > 1 ? pm : ph.mult;
      const entries = Math.round(base * q * (active ? mult : 1));
      const num = el.querySelector(".eb-num");
      if (num) num.textContent = entries.toLocaleString("en-US");
      let chip = el.querySelector(".eb-mult");
      if (active) {
        if (!chip) {
          el.appendChild(document.createTextNode(" "));
          chip = document.createElement("span"); chip.className = "eb-mult"; el.appendChild(chip);
        }
        chip.textContent = mult + "X";
        el.classList.remove("entry-badge--off");
        if (pm > 1) el.classList.add("entry-badge--boost");
      } else {
        if (chip) chip.remove();
        el.classList.add("entry-badge--off");
        el.classList.remove("entry-badge--boost");
      }
    });
    // Product page strip
    const pe = document.getElementById("peEntries");
    if (pe) {
      const pm = parseFloat(pe.dataset.pmult) || 0;
      const active = pm > 1 ? true : ph.active;
      const mult = pm > 1 ? pm : ph.mult;
      pe.dataset.mult = active ? mult : 1;
      const qtyEl = document.getElementById("qtyInput");
      const qty = Math.max(1, parseInt(qtyEl && qtyEl.value) || 1);
      const base = parseFloat(pe.dataset.base) || 0;
      pe.textContent = Math.round(base * (active ? mult : 1) * qty).toLocaleString("en-US");
      const strip = pe.closest(".pdp-entries");
      if (strip) {
        let chip = strip.querySelector(".pe-mult");
        if (active) {
          if (!chip) { chip = document.createElement("span"); chip.className = "eb-mult pe-mult"; strip.appendChild(chip); }
          chip.textContent = mult + "X";
        } else if (chip) chip.remove();
      }
    }
    // Cart summary total = sum of corrected line badges (page + drawer)
    document.querySelectorAll(".cse-num").forEach(cse => {
      const scope = cse.closest("#cdrInner") || cse.closest(".cart-summary");
      const lines = scope ? scope.querySelectorAll("[data-eb]") : [];
      // exclude upsell badges — only count actual cart lines
      let total = 0, found = false;
      lines.forEach(el => {
        if (el.closest(".cs-upsell")) return;
        found = true;
        const base = parseFloat(el.dataset.base) || 0;
        const q = parseFloat(el.dataset.q) || 1;
        const pm = parseFloat(el.dataset.pmult) || 0;
        const active = pm > 1 ? true : ph.active;
        const mult = pm > 1 ? pm : ph.mult;
        total += Math.round(base * q * (active ? mult : 1));
      });
      if (found) mdCountUp(cse, total);
      else mdCountUp(cse, parseInt(cse.textContent.replace(/[^0-9]/g, "")) || 0);
    });
  }
  /* Fast count-up animation for the Total Entries number */
  function mdCountUp(el, target) {
    if (el.dataset.counting === String(target)) return;
    el.dataset.counting = String(target);
    const start = performance.now(), dur = 750;
    const ease = t => 1 - Math.pow(1 - t, 3);
    function frame(now) {
      if (el.dataset.counting !== String(target)) return;
      const p = Math.min(1, (now - start) / dur);
      el.textContent = Math.round(target * ease(p)).toLocaleString("en-US");
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  mdSyncBadges();
  // re-sync at each phase boundary while the page is open
  (function scheduleResync() {
    const c = window.MDConfig || {};
    if (!Array.isArray(c.phases)) return;
    const now = Date.now() / 1000;
    const next = c.phases.map(p => p.end).find(e => e > now);
    if (next) setTimeout(() => { mdSyncBadges(); scheduleResync(); }, Math.min((next - now) * 1000 + 500, 2147000000));
  })();

  /* ---------- Countdown (phase-aware: rolls to the next promo phase live) ---------- */
  $$("[data-countdown], [data-phases]").forEach(el => {
    let phases = null;
    if (el.dataset.phases) {
      try { phases = JSON.parse(el.dataset.phases); } catch (e) { phases = null; }
    }
    el.innerHTML = ["Days", "Hours", "Mins", "Secs"].map(l =>
      `<div class="cd-unit"><div class="cd-num" data-cd="${l.toLowerCase()}">--</div><div class="cd-label">${l}</div></div>`).join("");
    const n = {}, prev = {};
    ["days", "hours", "mins", "secs"].forEach(k => n[k] = el.querySelector(`[data-cd="${k}"]`));
    const labelEl = el.closest("section") ? el.closest("section").querySelector(".cd-phase-label") : null;
    const headingTpl = el.dataset.headingTemplate || "[promo] ends in";

    let target, phaseIdx = -1;
    const pickPhase = () => {
      if (!phases) { target = new Date(el.dataset.countdown + "T23:59:59"); return; }
      const now = Date.now();
      let idx = phases.findIndex(p => p.end * 1000 > now);
      if (idx === -1) idx = phases.length - 1; // all over: pin to last, shows zeros
      if (idx !== phaseIdx) {
        phaseIdx = idx;
        target = new Date(phases[idx].end * 1000);
        if (labelEl) labelEl.textContent = headingTpl.replace("[promo]", phases[idx].label || "Bonus");
      }
    };
    pickPhase();

    const tick = () => {
      // rolled past the current phase? switch to the next one live
      if (phases && target - Date.now() <= 0 && phaseIdx < phases.length - 1) pickPhase();
      let d = Math.max(0, target - Date.now());
      const v = { days: Math.floor(d / 864e5), hours: Math.floor(d % 864e5 / 36e5), mins: Math.floor(d % 36e5 / 6e4), secs: Math.floor(d % 6e4 / 1e3) };
      Object.keys(v).forEach(k => {
        const s = String(v[k]).padStart(2, "0");
        if (prev[k] !== s) { n[k].textContent = s; n[k].classList.remove("tick"); void n[k].offsetWidth; n[k].classList.add("tick"); prev[k] = s; }
      });
      if (!phases && target - Date.now() <= 0) clearInterval(iv);
    };
    tick();
    const iv = setInterval(tick, 1000);
  });

  /* ---------- Accordions ---------- */
  $$(".faq-item").forEach(item => {
    const q = item.querySelector(".faq-q"), a = item.querySelector(".faq-a");
    if (!q || !a) return;
    q.setAttribute("aria-expanded", "false");
    q.addEventListener("click", () => {
      const open = item.classList.toggle("open");
      q.setAttribute("aria-expanded", open);
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0";
    });
  });

  /* ---------- AJAX cart: quick add ---------- */
  function refreshCount(count) {
    const cc = $("#cartCount");
    if (!cc) return;
    cc.textContent = count;
    cc.classList.toggle("zero", count === 0);
    cc.classList.remove("bump"); void cc.offsetWidth; cc.classList.add("bump");
  }
  async function addToCart(variantId, qty, title) {
    try {
      const res = await fetch(window.MDConfig.cartAddUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: qty })
      });
      if (!res.ok) { const err = await res.json(); toast({ title: err.description || "Couldn't add to cart" }); return; }
      const item = await res.json();
      const cart = await (await fetch("/cart.js")).json();
      refreshCount(cart.item_count);
      const m = window.MDConfig.multiplier, promo = window.MDConfig.promoActive;
      const entries = Math.round((item.final_price / 100) * (promo ? m : 1)) * qty;
      if (document.body.dataset.template === "cart") { location.reload(); return; }
      await cdrRefresh();
      cdrOpen();
    } catch (e) { toast({ title: "Couldn't add to cart" }); }
  }
  document.addEventListener("click", e => {
    const b = e.target.closest("[data-quick-add]");
    if (b) { e.preventDefault(); addToCart(b.dataset.quickAdd, 1, b.dataset.title); }
  });


  /* ---------- Cart drawer ---------- */
  const cdrBackdrop = () => $("#cdrBackdrop");
  function cdrOpen() {
    const b = cdrBackdrop(); if (!b) return;
    b.classList.add("open"); b.setAttribute("aria-hidden", "false");
    document.body.classList.add("cdr-open");
    const n = b.querySelector(".cse-num");
    if (n) { delete n.dataset.counting; }
    if (typeof mdSyncBadges === "function") mdSyncBadges();
  }
  function cdrClose() {
    const b = cdrBackdrop(); if (!b) return;
    b.classList.remove("open"); b.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cdr-open");
  }
  async function cdrRefresh() {
    try {
      const res = await fetch("/?sections=cart-drawer");
      const data = await res.json();
      const html = data["cart-drawer"];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector("#cdrInner");
      const cur = document.querySelector("#cdrInner");
      if (fresh && cur) { cur.replaceWith(fresh); if (typeof mdSyncBadges === "function") mdSyncBadges(); }
    } catch (e) {}
  }
  // Header cart icon opens the drawer instead of navigating
  document.addEventListener("click", e => {
    const cartLink = e.target.closest('a[href]');
    if (cartLink) {
      const href = cartLink.getAttribute("href") || "";
      if (href === "/cart" || href.endsWith("/cart") || href === (window.MDConfig && window.MDConfig.cartUrl)) {
        e.preventDefault(); cdrRefresh().then(cdrOpen);
      }
    }
    if (e.target.closest(".cdr-close")) cdrClose();
    const b = cdrBackdrop();
    if (b && e.target === b) cdrClose();
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") cdrClose(); });

  // Drawer steppers + remove
  document.addEventListener("click", async e => {
    const plus = e.target.closest("[data-cdr-plus]");
    const minus = e.target.closest("[data-cdr-minus]");
    const rm = e.target.closest("[data-cdr-remove]");
    if (!plus && !minus && !rm) return;
    e.preventDefault();
    const line = (plus || minus || rm).closest(".cdr-line");
    const key = plus ? plus.dataset.cdrPlus : minus ? minus.dataset.cdrMinus : rm.dataset.cdrRemove;
    let qty = 0;
    if (plus || minus) {
      const cur = parseInt(line.querySelector(".cdr-stepper span").textContent) || 1;
      qty = plus ? cur + 1 : Math.max(0, cur - 1);
    }
    line.style.opacity = ".45";
    try {
      const res = await fetch(window.MDConfig.cartChangeUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      refreshCount(cart.item_count);
      await cdrRefresh();
      if (document.body.dataset.template === "cart") location.reload();
    } catch (err) { line.style.opacity = ""; toast({ title: "Couldn't update cart" }); }
  });

  /* ---------- Cart page qty steppers (submit-based, reliable) ---------- */
  document.addEventListener("click", e => {
    const inc = e.target.closest("[data-cart-inc]"), dec = e.target.closest("[data-cart-dec]");
    if (!inc && !dec) return;
    const idx = (inc || dec).dataset.cartInc || (inc || dec).dataset.cartDec;
    const input = $(`[data-cart-qty="${idx}"]`);
    if (!input) return;
    input.value = Math.max(0, parseInt(input.value || 1) + (inc ? 1 : -1));
    input.closest("form").querySelector('[name="update"]').click();
  });

  /* ---------- Product page: variants · qty · entries · sticky ATC ---------- */
  const form = $("#productForm");
  if (form) {
    const dataEl = $("#variantData");
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = $("#variantId");
    const qtyInput = $("#qtyInput");
    const pe = $("#peEntries");
    const atc = $("#atcBtn");
    const money = c => "$" + (c / 100).toLocaleString("en-US", { minimumFractionDigits: c % 100 ? 2 : 0 });

    const selected = () => $$(".size-opts").map(g => g.querySelector(".selected")?.dataset.value);
    function syncVariant() {
      const sel = selected();
      const v = variants.find(v => v.options.every((o, i) => o === sel[i]));
      if (!v) return;
      idInput.value = v.id;
      const priceEl = $("[data-price]");
      if (priceEl) priceEl.textContent = money(v.price);
      atc.disabled = !v.available;
      atc.textContent = v.available ? "Add to cart" : "Sold out";
      updateEntries(v.price);
    }
    function updateEntries(priceCents) {
      const qty = Math.max(1, parseInt(qtyInput.value) || 1);
      let entriesTxt = "";
      if (pe) {
        let base = parseFloat(pe.dataset.base);
        if (pe.dataset.fromPrice !== "false" && priceCents) base = priceCents / 100;
        const mult = parseFloat(pe.dataset.mult) || 1;
        pe.textContent = Math.round(base * mult * qty).toLocaleString("en-US");
        entriesTxt = ` · ${pe.textContent} entries`;
      }
      const sa = $("#saPrice");
      if (sa && priceCents) sa.textContent = money(priceCents * qty) + entriesTxt;
    }
    $$(".size-opts").forEach(g => g.addEventListener("click", e => {
      const b = e.target.closest("[data-value]");
      if (!b) return;
      g.querySelectorAll("button").forEach(x => x.classList.remove("selected"));
      b.classList.add("selected");
      syncVariant();
    }));
    $("#qtyInc")?.addEventListener("click", () => { qtyInput.value = Math.min(99, (parseInt(qtyInput.value) || 1) + 1); syncVariant(); });
    $("#qtyDec")?.addEventListener("click", () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) - 1); syncVariant(); });
    qtyInput?.addEventListener("change", syncVariant);

    form.addEventListener("submit", e => {
      e.preventDefault();
      addToCart(idInput.value, Math.max(1, parseInt(qtyInput.value) || 1), atc.dataset.title);
    });

    // Gallery — finger-tracking slider
    const mi = $("#mainImg"), track = $("#pdpTrack");
    const slides = track ? $$(".pdp-slide", track) : [];
    const thumbs = $$(".pdp-thumbs button");
    let cur = 0;

    function goTo(i, animate) {
      if (!track) return;
      cur = Math.max(0, Math.min(slides.length - 1, i));
      track.classList.toggle("animating", animate !== false);
      track.style.transform = "translate3d(" + (-cur * 100) + "%,0,0)";
      slides.forEach((s, n) => s.classList.toggle("current", n === cur));
      if (thumbs.length) {
        thumbs.forEach(x => x.classList.remove("active"));
        const t = thumbs[cur];
        if (t) { t.classList.add("active"); t.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" }); }
      }
    }

    if (mi) {
      goTo(0, false);

      // Swipe — tracks the finger 1:1, velocity flicks, rubber-band edges.
      // touch-action: pan-y keeps vertical page scroll native; pointercancel snaps back.
      if (track && slides.length > 1) {
        let active = false, locked = false, pid = null;
        let startX = 0, startY = 0, dx = 0, w = 1;
        let lastX = 0, lastT = 0, vel = 0;

        mi.addEventListener("pointerdown", e => {
          if (e.pointerType === "mouse") return;
          active = true; locked = false; dx = 0; vel = 0;
          startX = lastX = e.clientX; startY = e.clientY; lastT = e.timeStamp;
          w = mi.clientWidth || 1; pid = e.pointerId;
          track.classList.remove("animating");
        });

        mi.addEventListener("pointermove", e => {
          if (!active || e.pointerId !== pid) return;
          const mx = e.clientX - startX, my = e.clientY - startY;
          if (!locked) {
            if (Math.abs(mx) > Math.abs(my) + 4 && Math.abs(mx) > 6) {
              locked = true;
              mi.classList.add("dragging");
              if (mi.setPointerCapture) { try { mi.setPointerCapture(pid); } catch (err) {} }
            } else if (Math.abs(my) > Math.abs(mx) + 4) { active = false; return; }
            else return;
          }
          dx = mx;
          let off = -cur * w + dx;
          const min = -(slides.length - 1) * w;
          if (off > 0) off /= 3;
          if (off < min) off = min + (off - min) / 3;
          track.style.transform = "translate3d(" + off + "px,0,0)";
          const dt = e.timeStamp - lastT || 16;
          vel = 0.8 * vel + 0.2 * ((e.clientX - lastX) / dt);
          lastX = e.clientX; lastT = e.timeStamp;
        });

        const finish = cancelled => {
          if (!active) return;
          active = false;
          mi.classList.remove("dragging");
          if (!locked) return;
          let target = cur;
          if (!cancelled) {
            if (Math.abs(vel) > 0.4) target = cur + (vel < 0 ? 1 : -1);
            else if (Math.abs(dx) > w * 0.22) target = cur + (dx < 0 ? 1 : -1);
          }
          goTo(target);
        };
        mi.addEventListener("pointerup", () => finish(false));
        mi.addEventListener("pointercancel", () => finish(true));
      }

      // Thumbs + keyboard
      thumbs.forEach((b, i) => b.addEventListener("click", () => goTo(i)));
      if (slides.length > 1) {
        mi.setAttribute("tabindex", "0");
        mi.addEventListener("keydown", e => {
          if (e.key === "ArrowRight") goTo(cur + 1);
          if (e.key === "ArrowLeft") goTo(cur - 1);
        });
      }
    }

    // Sticky ATC
    const sticky = $("#stickyAtc"), buy = $(".pdp-buy");
    if (sticky && buy && "IntersectionObserver" in window) {
      new IntersectionObserver(([en]) =>
        sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0),
        { threshold: 0 }).observe(buy);
    }
  }

  /* ---------- PDP intro read-more ---------- */
  const introWrap = $(".pdp-intro-wrap");
  if (introWrap) {
    const p = $(".pdp-intro", introWrap);
    const more = $("[data-intro-toggle]", introWrap);
    if (p && more) {
      // Only surface the toggle when the clamp is actually cutting text off
      if (p.scrollHeight > p.clientHeight + 2) more.hidden = false;
      more.addEventListener("click", () => {
        const open = introWrap.classList.toggle("open");
        more.setAttribute("aria-expanded", open ? "true" : "false");
        more.textContent = open ? "Read less −" : "Read more ＋";
      });
    }
  }

  /* ---------- Collection filter drawer ---------- */
  const fdrB = $("#fdrBackdrop");
  if (fdrB) {
    const fOpen = () => { fdrB.classList.add("open"); fdrB.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; };
    const fClose = () => { fdrB.classList.remove("open"); fdrB.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; };
    $$("[data-filter-open]").forEach((b) => b.addEventListener("click", fOpen));
    fdrB.addEventListener("click", (e) => {
      if (e.target === fdrB || e.target.closest("[data-filter-close]")) fClose();
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && fdrB.classList.contains("open")) fClose(); });
  }

  /* ---------- Collection sort ---------- */
  const sort = $("[data-sort]");
  if (sort) sort.addEventListener("change", () => {
    const url = new URL(location.href);
    url.searchParams.set("sort_by", sort.value);
    location.href = url.toString();
  });
})();
